import Faqs from "@/components/landing/home/Faqs";
import AppDownload from "@/components/landing/homeFour/AppDownload";
import Banner from "@/components/landing/homeFour/Banner";
import CallToAction from "@/components/landing/homeFour/CallToAction";
import Features from "@/components/landing/homeFour/Features";
import HowItsWork from "@/components/landing/homeFour/HowItsWork";
import MarketSolutions from "@/components/landing/homeFour/MarketSolutions";
import Testimonials from "@/components/landing/homeFour/Testimonials";

export default function HomeFour() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* Features section */}
      <Features />

      {/* App Download section */}
      <AppDownload />

      {/* How Its Work section */}
      <HowItsWork />

      {/* Market Solutions section */}
      <MarketSolutions />

      {/* Testimonials section */}
      <Testimonials />

      {/* Call To Action section */}
      <CallToAction />

      {/* Faqs section */}
      <Faqs />
    </>
  );
}
